import { cardsData } from '@/mocks/homeData';

export default function Cards() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-primary-100 text-primary-700 rounded-full mb-3 whitespace-nowrap">
            <i className="ri-newspaper-line mr-1"></i>精选内容
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            热门爆料
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            精选每日最热黑料合集，一次看完精彩爆料内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardsData.map((card) => (
            <article
              key={card.id}
              className="group bg-background-100 border border-background-200/60 rounded-xl overflow-hidden hover:border-background-300/60 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[4/3] overflow-hidden bg-background-200">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.target as HTMLImageElement).style.display = 'none';
                    const parent = (e.target as HTMLImageElement).parentElement;
                    if (parent) {
                      parent.style.display = 'none';
                    }
                  }}
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-semibold bg-primary-500 text-white rounded-md whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
                <div className="absolute bottom-3 right-3">
                  <span className="px-2 py-1 text-xs bg-black/60 text-white rounded-md whitespace-nowrap backdrop-blur-sm">
                    {card.time}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                  {card.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {card.summary}
                </p>
                <div className="mt-4 flex items-center gap-4 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {card.views}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-chat-3-line"></i>
                    {card.comments}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="text-center mt-8 md:mt-10">
          <a
            href="#index"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 border border-background-200/60 text-foreground-700 font-medium rounded-xl hover:bg-background-200 transition-colors text-sm whitespace-nowrap cursor-pointer"
          >
            查看更多爆料
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}